import UserDefaultLayout from "@/User/Layouts/DefaultLayout";
import { createInertiaApp } from '@inertiajs/react';
import React from 'react';
import { createRoot, hydrateRoot } from "react-dom/client";
import route from 'ziggy-js';
import { Ziggy } from './ziggy.js';
import { USER_HOMEPAGE_COMPONENT } from "./utils.jsx";

// Load assets images file to public when Vite building
import.meta.glob([
    '../images/**',
]);

window.Ziggy = Ziggy;

createInertiaApp({
    resolve: name => {
        const isAppUrl = route().current('app.*');
        const pageDir = isAppUrl ? './App' : './User/Pages';
        let pages = {};

        if (isAppUrl) {
            pages = import.meta.glob('./App/**/*.jsx');
        } else if (name === USER_HOMEPAGE_COMPONENT) {
            pages = import.meta.glob('./User/Pages/Top/Index.jsx');
        } else {
            pages = import.meta.glob('./User/Pages/**/*.jsx');
        }
        const page = pages[`${pageDir}/${name}.jsx`]();

        if (!isAppUrl) {
            page.then(function (result) {
                result.default.layout = result.default.layout || (result => <UserDefaultLayout>{result}</UserDefaultLayout>);
            });
        }
        return page;
    },
    setup({ el, App, props }) {
        // Run SSR after build, else run only CSR
        if (import.meta.env.PROD) {
            hydrateRoot(el, <App {...props} />);
        } else {
            createRoot(el).render(<App {...props} />);
        }
    },
    progress: {
        // The delay after which the progress bar will
        // appear during navigation, in milliseconds.
        delay: 50,
        // The color of the progress bar.
        color: '#035397',
    }
});
